module.exports = __webpack_public_path__ + "img/TAB_04_Active.f889971c.svg";